import { configureStore } from '@reduxjs/toolkit';
import rootReducer from 'reducers';
import { LSAvailable } from 'utils/localStorageHandler';
// import { sentryReduxEnhancer } from 'services/sentry';
import { airMeshMiddleware } from 'services/airMeshMiddleware';
// import { REACT_APP_ENV } from 'constants/environmentVariables';
import {
	initialGlobalState,
	initialUserAuthState,
	initialMapState,
	initialActivitiesState,
	initialFileUploadState,
	initialFlightPathViewerState,
	initialLaancState,
	initialUSpaceState,
	initialLiveTrafficState,
	initialOperatingPictureState,
	initialManageTablesState,
	initialReportsState,
	initialRolesState,
	initialStreamingState
} from 'reducers/initialStates';
import { broadcastMiddleware } from 'services/broadcastingMiddleware';

export const initialStoreState = {
	userAuth: initialUserAuthState,
	global: initialGlobalState,
	map: initialMapState,
	activities: initialActivitiesState,
	fileUpload: initialFileUploadState,
	flightPathViewer: initialFlightPathViewerState,
	laanc: initialLaancState,
	uspace: initialUSpaceState,
	liveTraffic: initialLiveTrafficState,
	operatingPicture: initialOperatingPictureState,
	manageTables: initialManageTablesState,
	reports: initialReportsState,
	roles: initialRolesState,
	streaming: initialStreamingState
};

export const setupStore = () => {
	const lsAvailable = LSAvailable(); //This app requires localStorage to be enabled and available. This is the first place in the app that localStorage is used.
	if (lsAvailable) {
		return configureStore({
			reducer: rootReducer,
			// Middleware setup to disable warnings. Ref: https://redux-toolkit.js.org/api/getDefaultMiddleware#api-reference
			middleware: getDefaultMiddleware => [
				airMeshMiddleware(),
				broadcastMiddleware,
				...getDefaultMiddleware({
					serializableCheck: false,
					immutableCheck: false
				})
			],
			//Disable dev tools except for development environment.
			//Note - always ensure dev tools is disabled when testing app memory usage (only test memory usage in production builds).
			// devTools:
			// 	REACT_APP_ENV === 'development'
			// 		? {
			// 				actionsDenylist: ['liveTraffic', 'HYDRATE_REDUX', 'map/setGeoJsonData']
			// 			}
			// 		: false,
			enhancers: getDefaultEnhancers => getDefaultEnhancers(),
			preloadedState: initialStoreState
		});
	}
};

export const reduxStore = setupStore();
